<template>
     <article class="rlc-slide swiper-slide rlc-ticker-item">
        {{text}}

        <br v-if="lineBreak" />
        <div v-for="link in cta" :key="link.id" style="display: inline-block;">
            <span v-if="link.checkedCTA"> | </span>
            <a class="promo-msg" href="" v-if="link.checkedCTA === 'Pop Up Message'">
                <span class="rlc-link-underline">
                    <u>{{link.ctaText}}</u>
                </span>

                <div class="promo-msg-content" style="display:none;" >
                    <div class="promo-wrap">{{link.ctaValue}}</div> 
                </div>
            </a>

            <a :href="link.ctaValue" v-if="link.checkedCTA === 'Link'"><u> {{link.ctaText}}</u></a>

            <u v-if="link.checkedCTA === 'PDF'"><a target="_blank"
            :href="`../../../Library-Sites-RalphLauren_EU_Library/default/content/pdf/`+link.ctaValue+`?$staticlink$`"> {{link.ctaText}}</a></u>

        </div>

   

       


     
      </article>
</template>

<script setup>
import { fieldFactory } from '@/helper/fieldFactory';
import { store } from '@/helper/store';
const props = defineProps({
    storeId:String
})

const text = fieldFactory('text', props.storeId)
const cta = fieldFactory('cta', props.storeId)
const lineBreak = fieldFactory('lineBreak', props.storeId)


</script>

<style>
</style>